import { GraduationCap } from 'lucide-react';

/**
 * Markierung für Bestellungen aus der Einführungstour.
 *
 * Bewusst dezent in Gold statt in Warnfarbe: eine Übungsbestellung ist
 * kein Fehler, sondern ein Lernstück. Sie soll erkennbar sein, ohne die
 * Aufmerksamkeit zu binden — schließlich sieht sie ohnehin nur der
 * eine Mensch, der gerade übt.
 *
 * WARUM DER TEXT NICHT MEHR GOLD IST — gemessen (A30.2)
 *   Bis hierher stand er in gold-dark (#8A7A4A) auf gold-soft
 *   (#F2EBD9). Im gebauten Stand nachgerechnet sind das 3,56:1, und die
 *   Untergrenze für Text liegt bei 4,5:1 — bei 12 Pixeln erst recht.
 *   Aufgefallen ist es, weil seit A26 das Geschenk-Merkzeichen direkt
 *   daneben steht, das mit 11,91:1 darüber liegt: zwei gleich gebaute
 *   Zeichen, eines lesbar, eines nicht.
 *
 *   Der Text steht deshalb in Ink (#2B2B2B). Keine neue Farbe erfunden,
 *   beide Werte stehen in der Palette.
 *
 *   DER RAHMEN BLEIBT, WIE ER IST (2,12:1), und das ist Absicht: Er
 *   trägt keine Auskunft, er fasst sie ein. Die 3:1-Regel gilt für
 *   Elemente, die etwas mitteilen — hier sind das Text und Symbol.
 */
export function UebungBadge() {
  return (
    <span
      data-tour="uebung-badge"
      className="inline-flex items-center gap-1 rounded-full border border-gold bg-gold-soft px-2 py-0.5 text-xs text-ink"
      title="Übungsbestellung der Einführungstour. Nur du siehst sie, und sie verschwindet am Ende wieder."
    >
      <GraduationCap aria-hidden className="h-3 w-3 text-gold-dark" />
      Übung
    </span>
  );
}
